import { render, staticRenderFns } from "./ChooseScreen.vue?vue&type=template&id=71616f3e&scoped=true"
import script from "./ChooseScreen.vue?vue&type=script&lang=ts"
export * from "./ChooseScreen.vue?vue&type=script&lang=ts"
import style0 from "./ChooseScreen.vue?vue&type=style&index=0&id=71616f3e&prod&lang=scss"
import style1 from "./ChooseScreen.vue?vue&type=style&index=1&id=71616f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71616f3e",
  null
  
)

export default component.exports